// extracted by mini-css-extract-plugin
export default {"banner":"cookie-banner_banner__x6vLO","text":"cookie-banner_text__oTjTr","actions":"cookie-banner_actions__0bQct","actions--stacked":"cookie-banner_actions--stacked__3ojTE"};